import convertUnit from '../../../utils/unit-converter';
import {
  IceUnitKey,
  IceUnits,
} from '../../../constants/IceUnit';
import { Measurement } from '../../../constants/Configuration';

/**
 * Ice melts and becomes water.
 * This function calculates the adjustment to be made to the water quantity.
 * @todo Ice is denser than water, unit converter should take that into account.
 * @todo Function used in multiple places, should be moved to shared utils.
 */
export const calculateIceAdjustment = (
  ice: string | number,
  iceUnitKey: IceUnitKey,
  quantityToBeBatched: number,
  waterUnit: string,
  perLoad?: boolean,
) => {
  let iceAdjustment = 0;
  if (!ice || !iceUnitKey || !quantityToBeBatched) {
    return 0;
  }

  // Get unit info from all available ice units (combine metric and US units)
  const allIceUnits = [...IceUnits[Measurement.Metric], ...IceUnits[Measurement['U.S. Customary']]];
  const iceUnitInfo = allIceUnits.find(unit => unit.key === iceUnitKey);

  if (!iceUnitInfo) {
    throw new Error(`Calculate ice adjustment: Ice unit ${iceUnitKey} not found`);
  }

  const isCompoundUnit = iceUnitInfo.isCompoundUnit || false;
  const baseUnit = iceUnitInfo.baseUnit;

  if (perLoad) {
    iceAdjustment = isCompoundUnit
      ? convertUnit(Number(ice), baseUnit, waterUnit) * quantityToBeBatched
      : convertUnit(Number(ice), baseUnit, waterUnit);
  } else {
    iceAdjustment = isCompoundUnit
      // Adjust ice not as per load, but as per batch
      // Works similar to trim ↓
      ? convertUnit(Number(ice), baseUnit, waterUnit)
      : convertUnit(Number(ice), baseUnit, waterUnit) / quantityToBeBatched;
  }

  return iceAdjustment;
};
